import { Result, Row } from "antd";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import Button from "../../components/Button";
import { ReactComponent as XPLogo } from "../../assets/xp.svg";
import VeloprimeLogo from "../../assets/veloprime/logo-veloprime-horizontal-white.png";

export const Container = styled.div`
  height: 100vh;
  background-color: var(--veloprime-background-color);
  .ant-result-subtitle,
  .ant-result-title {
    color: var(--white);
  }
  svg.error * {
    fill: var(--ant-error-color);
  }
`;

const PageNotFound: React.FC = () => {
  const navigate = useNavigate();
  return (
    <Container>
      <Result
        icon={<img src={VeloprimeLogo} alt="Logo" style={{ width: "100px", height: "auto"  }} />}
        title="Página não encontrada"
        subTitle="Esta página que você visitou não existe"
        extra={
          <Row justify="center">
            <Button
              size="large"
              type="primary"
              onClick={() => navigate("/clients")}
            >
              Voltar para o app
            </Button>
          </Row>
        }
      />
    </Container>
  );
};

export default PageNotFound;
